import React from 'react';

export const InputGroupContext = React.createContext({});
export const ModalContext = React.createContext({});
export const TreeContext = React.createContext({});
export const CollapseContext = React.createContext({ active: [] });
CollapseContext.displayName = 'CollapseContext';

export const RadioGroupContext = React.createContext({});
export const MenuContext = React.createContext({});
export const NavbarContext = React.createContext({});
export const DateContext = React.createContext({});
export const FormItemContext = React.createContext({});
export const RowContext = React.createContext(null);
export const ThemeContext = React.createContext(null);
export const StepperContext = React.createContext(null);
